import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";

export type StartImpersonationResponseDTO = {
  token: string;
  tenantId: string | null;
  impersonationId: string;
  target?: {
    uid: string;
    email?: string | null;
    practiceName?: string | null;
  };
};

export const ImpersonationAPI = {
  async start(params: {
    targetLawyerId: string;
    reason: string;
  }): Promise<StartImpersonationResponseDTO> {
    try {
      const response = await axiosInstance.post<StartImpersonationResponseDTO>(
        "/admin/impersonations/start",
        {
          targetLawyerId: params.targetLawyerId,
          reason: params.reason
        }
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async end(): Promise<{ ok: true }> {
    try {
      const response = await axiosInstance.post<{ ok: true }>(
        "/admin/impersonations/end",
        {}
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
